export default __webpack_public_path__ + "static/media/120_future_funk_beats_25.5eb417fc.mp3";